import { Stack, StackProps, styled, Theme } from "@mui/material";
import { Star } from "lucide-react";
import { Icon } from "../../components/Icon";

export const CtaOverlayContainer = styled(Stack)<{ isMobile:boolean, mobileCtaOverlayShow: boolean }>(({ 
  theme,
  isMobile,
  mobileCtaOverlayShow
}) => ({
  backgroundColor: theme.customColors.backgroundPrimary,
  border: `2px solid ${theme.customColors.textPrimary}`,
  borderRadius: "0.5rem",
  bottom: "1rem",
  flexDirection: "row",
  height: "2.5rem",
  // overflow: "hidden",
  display: "flex",
  position: "absolute",
  right: !isMobile ? "2.5rem" : "1rem",
  zIndex: 999,
  ".button":{
    borderRight: `2px solid ${theme.customColors.textPrimary}`
  },
  ".button:last-child":{
    borderRight: "none",
    borderTopRightRadius: "0.5rem",
    borderBottomRightRadius: "0.5rem"
  },
  ".button:first-child":{
    borderTopLeftRadius: "0.5rem",
    borderBottomLeftRadius: "0.5rem"
  },
  ".button:focus":{
    backgroundColor: theme.customColors.backgroundSecondaryCtaHover
  },
  ...(isMobile && {
    display: !mobileCtaOverlayShow ? "none" : "flex",
    bottom: "4rem"
  })
}));

export const StarsBoxContainer = styled(Stack)<
  StackProps & {
    $visibility?: boolean,
    $isMobile?: boolean
  }
>(({ $visibility=false, theme, $isMobile }) => ({
  alignItems: "center",
  background: theme.customColors.backgroundPrimary,
  border: `2px solid ${theme.customColors.textPrimary}`,
  borderRadius: "0.5rem",
  display: "flex",
  flexDirection: "row", 
  // flexDirection: "row", 
  gap: "0.7rem",
  height: "2.5rem",
  justifyContent:"center",
  left: !$isMobile ? "50%" : "-2.25rem",
  padding: "0.78rem",
  position: "absolute",
  top: $visibility ? "-0.5rem" : "0.5rem",
  opacity: $visibility ? 1 : 0,
  transform: "translate(-50%, -100%)",
  transition: "all 0.2s ease-out"
}));





export const StarIcon = styled(Star)(() => ({
  cursor: "pointer",
  transition: "all 0.15s",
  ":focus:not(:focus-visible)": {
    outline: "none"
  }
}));


export const CtaOverlayIcon = styled(Icon)(({ icon, theme }:{icon:string, color?: string, theme: Theme}) => ({
  "&":
    {
      "&.withpadding": {
        width: "100% !important",
        height: "44px !important",
        padding: "12px",
        [theme.breakpoints.down(769)]: {
          padding: "4px"
        }
      },
      "&.onhover_ctaoverlay:hover":{
        "path":{
          fill: theme.customColors.textPrimary,
          stroke: theme.customColors.textPrimary,
          transform:
          icon === "Icons_rating_active"
            ? "scale(1.2) translate(-190px, -190px)"
            : icon ===
            "Star3-5" ? "scale(1.2) translate(-170px, -190px)" :
              icon === "Icons_salva-preferito_glow" ?
                "scale(1.2) translate(-50px, -50px)"
                : undefined
        }
      },
      /*"&.star": {
        marginTop: "10px"
      },*/
      "&.star svg": {
        marginTop: "5px"
      },
      "path":
      {
        fill: theme.customColors.textPrimary,
        stroke: theme.customColors.textPrimary,
        transform:
          icon === "Icons_rating_active"
            ? "scale(1.2) translate(-190px, -190px)"
            : icon ===
            "Star3-5" ? "scale(1.2) translate(-170px, -190px)" :
              icon === "Icons_salva-preferito_glow" ?
                "scale(1.2) translate(-50px, -50px)"
                : undefined
      }
    }
}));

